import React from "react";
import { useLang } from "@/context/LanguageContext";
import { StarIcon, PawScatter } from "@/components/Icons";
import Reveal from "@/components/Reveal";

const avatars = [
  "linear-gradient(135deg, #f7c5c0, #f4956a)",
  "linear-gradient(135deg, #a8d5ba, #76b990)",
  "linear-gradient(135deg, #fff1c2, #f7d97a)",
];

const Testimonials = () => {
  const { t } = useLang();
  return (
    <section className="py-20 sm:py-28 bg-[#fdf3ec] relative overflow-hidden" data-testid="testimonials-section">
      <PawScatter count={6} />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
        <Reveal className="text-center max-w-2xl mx-auto mb-12">
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl">
            {t.testimonials.title} <span className="text-[#f4956a]">⭐</span>
          </h2>
          <p className="text-[#6b3f2a]/75 mt-4 text-sm sm:text-base">{t.testimonials.subtitle}</p>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {t.testimonials.items.map((it, i) => (            <Reveal key={i} delay={i * 100}>
              <article
                className="cute-card h-full flex flex-col"
                data-testid={`testimonial-${i}`}
              >
                <div className="flex items-center gap-3 mb-4">
                  <div
                    className="w-12 h-12 rounded-full flex items-center justify-center text-white text-xl font-display shadow-md"
                    style={{ background: avatars[i % avatars.length] }}
                  >
                    {it.name.charAt(0)}
                  </div>
                  <div>
                    <p className="font-display text-base text-[#6b3f2a]">
                      {it.name} <span>{it.pet}</span>
                    </p>
                    <div className="flex gap-0.5 text-[#f4956a]">
                      {[0, 1, 2, 3, 4].map((s) => (
                        <StarIcon key={s} size={14} />
                      ))}
                    </div>
                  </div>
                </div>
                <p className="text-[#6b3f2a]/85 text-sm leading-relaxed flex-1">
                  “{it.text}”
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
